/**
 * Pure view for the password reset requested screen
 */
import React, { FunctionComponent, useEffect, useRef, useState } from 'react';
import NewUserButton from './common/new-user-button';

const SPINNER_TIME_MS = 2000;

interface IPasswordResetRequestedViewProps {
    backToLogin: () => void; // Callback to send the user back the the login screen
    checkPasswordResetGranted: () => void; // Check to see if the password has been reset but the teacher
}

const PasswordResetRequestedView: FunctionComponent<IPasswordResetRequestedViewProps> = ({
    backToLogin,
    checkPasswordResetGranted,
}: IPasswordResetRequestedViewProps): JSX.Element => {
    const [showSpinner, setShowSpinner] = useState<boolean>(false);
    const timer = useRef<number | null>(null);

    // If the spinner shows, set a timer to clear it after 2 seconds:
    useEffect(() => {
        if (showSpinner) {
            timer.current = window.setTimeout(() => {
                setShowSpinner(false);
            }, SPINNER_TIME_MS);
        }
    }, [showSpinner]);

    // If the timer is running for the spinner when component unmounts, clear it:
    useEffect(
        () => () => {
            if (timer.current !== null) {
                window.clearTimeout(timer.current);
            }
        },
        [],
    );

    return (
        <div className="new-user-password-reset-requested-page">
            <div className="new-user-view-content">
                <div className="new-user-view-box new-user-password-reset-requested-box">
                    <p className="new-user-password-reset-requested-text">
                        Ok, we&apos;ve let your teacher know that you want to reset your password -
                        refresh this page to see if you can reset your password after your teacher
                        has reset it for you
                    </p>

                    <div className="new-user-view-form-button-group new-user-choose-password-btn-group new-user-confirm-details-button-group">
                        <NewUserButton
                            type="button"
                            value="Back to login"
                            handleClick={backToLogin}
                        />

                        <NewUserButton
                            type="submit"
                            value="Refresh"
                            showIcon={false}
                            handleClick={() => {
                                setShowSpinner(true);
                                checkPasswordResetGranted();
                            }}
                            showSpinner={showSpinner}
                            disabled={showSpinner}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PasswordResetRequestedView;
